module.exports = __webpack_public_path__ + "d96a902346d81ca40bd239baaa37601f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/fin-risk-green-esg.jpg
// module id = 1959
// module chunks = 0